import { Typography } from '@/ui/atoms/typography/Typography'
import { cn } from '@/ui/utils/style'
import type { ReactNode } from 'react'

export interface PageHeroCompactProps {
  title: string
  titleAdornment?: ReactNode
  statsSlot?: ReactNode
  pillNav?: ReactNode
  className?: string
}

export function PageHeroCompact({ title, titleAdornment, statsSlot, pillNav, className }: PageHeroCompactProps) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-lg bg-gradient-to-br from-gradient-yellow/5 via-background to-gradient-green/5 px-4 py-4 md:px-10 md:py-6',
        className,
      )}
    >
      <div className="-top-24 -right-24 absolute h-48 w-48 rounded-full bg-gradient-to-br from-gradient-yellow/20 to-gradient-green/20 blur-[80px]" />
      <div className="-bottom-24 -left-24 absolute h-48 w-48 rounded-full bg-gradient-to-br from-gradient-green/20 to-gradient-yellow/20 blur-[80px]" />

      {/* Desktop: title left, stats + nav right */}
      <div className="relative hidden animate-fade-in-slow items-center justify-between gap-4 opacity-0 sm:flex">
        <div className="flex items-center gap-2">
          <Typography variant="h2" className="text-xl sm:text-4xl" gradient>
            {title}
          </Typography>
          {titleAdornment}
        </div>
        <div className="flex flex-col items-end gap-3">
          {statsSlot}
          {pillNav}
        </div>
      </div>

      {/* Mobile: title → stats → nav stacked */}
      <div className="relative flex animate-fade-in-slow flex-col items-start gap-3 opacity-0 sm:hidden">
        <div className="flex items-center gap-2">
          <Typography variant="h2" className="text-xl sm:text-4xl" gradient>
            {title}
          </Typography>
          {titleAdornment}
        </div>
        {statsSlot}
        {pillNav}
      </div>
    </div>
  )
}
